import { CardGrid } from '@weareopenr/component-library';
import NewItemCard from '../../NewItemCard';
import MenuItemCard from '../../MenuItemCard';
import { IMenuItem } from 'src/types/menu.types';

interface IMenuItemCardContainer {
  menuId: string;
  items: IMenuItem[];
  newItemButtonTitle: string;
  handleNewItemClick: () => void;
}

const MenuItemCardContainer = ({ menuId, items, newItemButtonTitle, handleNewItemClick }: IMenuItemCardContainer) => {
  return (
    <CardGrid>
      {[
        ...items.map((menuItem: IMenuItem) => {
          return (
            <MenuItemCard
              {...menuItem}
              key={menuItem.itemId}
              prices={[]}
              menuId={menuId}
              parentItemId={menuItem.parentItemId}
            />
          );
        }),
        <NewItemCard text={newItemButtonTitle} onClick={handleNewItemClick} key="new" />,
      ]}
    </CardGrid>
  );
};

export default MenuItemCardContainer;
